<template>
  <span class="agreement-link" @click="onClick">{{ text }}</span>
</template>

<script>
export default {
  props: {
    text: String,
    type: String
  },
  methods: {
    onClick() {
      this.$emit('click-agreement', this.type);
    }
  }
}
</script>

<style scoped>
.agreement-link {
  color: #409EFF;
  cursor: pointer;
}
</style>
